<script>
export default {
  name: "ModalExport",
  props: ["data"],
  data: () => ({
    appRoot: "",
  }),
  computed: {
    formReport: {
      get() {
        return this.$store.getters.formReport;
      },
    },
  },
  components: {},
  methods: {
    downloadCSVDataFull: async function() {
      var res = await this.$store.dispatch("getDataReport", true);

      var BOM = "\uFEFF";
      let csv =
        "Estado;Lead;Email;Telefone;Cargo;Empresa;Site_Empresa;Tamanho_Empresa;Data_Criacao;Pergunta;Resposta;Peso;Resultado\n";

      res.data.map((row) => {
        let arr = [
          row.answerId ? "Finalizado" : "Lead",
          row.name,
          row.email,
          row.corporate_phone,
          row.position,
          row.company_name,
          row.company_website,
          row.company_size,
          row.createdAt,
          row.question,
          row.answer,
          row.score,
          this.appRoot + /result/ + row.externalId,
        ];
        csv += arr.join(";");
        csv += "\n";
      });

      const anchor = document.createElement("a");
      anchor.href =
        "data:text/csv;charset=utf-8," + BOM + encodeURIComponent(csv);
      anchor.target = "_blank";
      anchor.download = `metadxi_full.csv`;
      anchor.click();
    },
    downloadCSVDataFilter: async function() {
      var res = await this.$store.dispatch("getDataReport", false);

      // converte a data do formtado dd/mm/yyyy para yyyy-mm-dd
      let dateIn = this.formReport.DateIn;
      let dateOut = this.formReport.DateOut;

      let dateInFormat = dateIn;
      let dateOutFormat = dateOut;

      var BOM = "\uFEFF";
      let csv =
        "Estado;Lead;Email;Telefone;Cargo;Empresa;Site_Empresa;Tamanho_Empresa;Data_Criacao;Pergunta;Resposta;Peso;Resultado\n";

      res.data.map((row) => {
        let arr = [
          row.answerId ? "Finalizado" : "Lead",
          row.name,
          row.email,
          row.corporate_phone,
          row.position,
          row.company_name,
          row.company_website,
          row.company_size,
          row.createdAt,
          row.question,
          row.answer,
          row.score,
          this.appRoot + /result/ + row.externalId,
        ];
        csv += arr.join(";");
        csv += "\n";
      });

      const anchor = document.createElement("a");
      anchor.href =
        "data:text/csv;charset=utf-8," + BOM + encodeURIComponent(csv);
      anchor.target = "_blank";
      anchor.download = `metadxi_${dateInFormat}_${dateOutFormat}.csv`;
      anchor.click();
    },
  },
  created() {
    this.appRoot = process.env.VUE_APP_ROOT;
  },
};
</script>
<template>
  <div id="ModalExport">
    <div class="content">
      <div
        class="close"
        @click="
          $emit('close');
          $emit('forceClose');
        "
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-6 w-6"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M6 18L18 6M6 6l12 12"
          />
        </svg>
      </div>
      <div class="controls">
        <!-- <button @click="downloadCSVData()">CSV para importação</button> -->
        <button @click="downloadCSVDataFilter()">Range</button>
        <button @click="downloadCSVDataFull()">Baixar tudo</button>
      </div>
    </div>
  </div>
</template>
<style lang="scss">
#ModalExport {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #0000009c;
  display: flex;
  justify-content: center;
  align-items: center;

  .content {
    width: 400px;
    height: 220px;
    background: white;
    margin-top: -20%;
    position: relative;

    .close {
      position: absolute;
      right: 0;
      cursor: pointer;
    }

    .controls {
      display: flex;
      justify-content: center;
      align-items: center;
      align-content: center;
      flex-direction: column;
      flex-wrap: nowrap;
      height: 100%;

      button {
        min-width: 234px;
        margin: 7px 0;
        background: #3b82f6;
        color: #ffffff;
      }
    }
  }
}
</style>
